export default "./images/survio-zs90X-assets-even.png";